import {useMemo} from "react";
import {css} from "@panda/css";

import {PhoneIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";

import {ClipPhoneButton} from "../../../atoms/ClipPhoneButton";
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {AmplitudeOfferPageButtonName, trackAmplitudeOfferButtonClick} from "../../../tracking/amplitude/track_amplitude_offer_button_click";
import {gtmRotatingPhoneNumbersCall, gtmRotatingPhoneNumbersReveal} from "../../../tracking/google_tag_manager/gtm_rotating_phone_numbers";

interface IProps {
    isAutoresponderEnabled: boolean;
    isDataFetched: boolean;
    offerId?: number;
    offer?: IOfferDetailApplication | null;
    propertyId?: number;
    optionalOfferPhoneData?: {
        configuration: {
            phone_clip: string | null;
        };
        is_phone_clip_enabled: boolean;
    };
    useHotlineNumber?: boolean;
}

export const ApplicationFormBoxPhoneNumber = (props: IProps) => {
    const fallbackPhoneNumber = useMemo(
        () =>
            (props.optionalOfferPhoneData?.is_phone_clip_enabled && props.optionalOfferPhoneData.configuration.phone_clip) ||
            (props.isDataFetched && props.offer?.is_phone_clip_enabled && props.offer?.configuration.phone_clip) ||
            (props.isDataFetched &&
                props.offer?.sales_offices &&
                props.offer?.sales_offices.length &&
                (props.offer.sales_offices[0].phone || props.offer.sales_offices[0].mobile)) ||
            null,
        [props.optionalOfferPhoneData, props.isDataFetched, props.offer]
    );

    const trackPhoneButtonClick = (buttonName: AmplitudeOfferPageButtonName) => {
        if (!props.offerId) {
            return;
        }

        trackAmplitudeOfferButtonClick({
            buttonName,
            buttonCategory: props.propertyId != null ? "property_page" : "investment_page",
            itemId: props.offerId
        });
    };

    const handleShowPhoneNumberClick = () => {
        gtmRotatingPhoneNumbersReveal();

        trackPhoneButtonClick("offer_show_number");
    };

    const handlePhoneNumberClick = () => {
        gtmRotatingPhoneNumbersCall();

        trackPhoneButtonClick("offer_call_investor");
    };

    if (!props.isDataFetched) {
        return <Loader size="md" className={loaderStyle} />;
    }

    return !props.isAutoresponderEnabled ? (
        <>
            <Text align="center" className={separatorTextStyle} color="var(--colors-gray-700)" variant="info_txt_2">
                lub zadzwoń
            </Text>

            <ClipPhoneButton
                buttonSize="medium"
                buttonStyleOverride={buttonStyleOverride}
                fallbackNumber={fallbackPhoneNumber}
                onClickPhoneNumber={handlePhoneNumberClick}
                onShowPhoneNumber={handleShowPhoneNumberClick}
                propertyId={props.propertyId}
                className={phoneButtonWrapperStyle}
                customPhoneButton={(onClick, phoneNumber) => (
                    <div className={columnCenterStyle}>
                        <div className={phoneSectionStyle}>
                            <PhoneIcon size="2.4" wrapperColor="var(--colors-primary)" wrapperSize="4" />

                            <Link className={linkStyle} href={`tel:+${phoneNumber}`} onClick={onClick}>
                                <Text as="span" variant="headline_6" color="var(--colors-secondary)">
                                    {phoneNumberFormat(phoneNumber)}
                                </Text>
                            </Link>
                        </div>
                    </div>
                )}
                useHotlineNumber={props.useHotlineNumber}
            />
        </>
    ) : null;
};

const separatorTextStyle = css({
    my: 2
});

const buttonStyleOverride = css({
    px: 2,
    py: 1,
    maxHeight: "40px"
});

const columnCenterStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
});

const phoneSectionStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});

const linkStyle = css({
    marginLeft: 2,
    "&, &:link, &:visited, &:hover, &:active": {
        textDecoration: "none",
        color: "inherit"
    }
});

const phoneButtonWrapperStyle = css({
    width: "100%",
    textAlign: "center"
});

const loaderStyle = css({
    w: "100%",
    h: "76px",
    alignItems: "center",
    marginTop: 2,
    opacity: 0.5
});
import {useMemo} from "react";
import {css} from "@panda/css";

import {PhoneIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";

import {ClipPhoneButton} from "../../../atoms/ClipPhoneButton";
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {AmplitudeOfferPageButtonName, trackAmplitudeOfferButtonClick} from "../../../tracking/amplitude/track_amplitude_offer_button_click";
import {gtmRotatingPhoneNumbersCall, gtmRotatingPhoneNumbersReveal} from "../../../tracking/google_tag_manager/gtm_rotating_phone_numbers";

interface IProps {
    isAutoresponderEnabled: boolean;
    isDataFetched: boolean;
    offerId?: number;
    offer?: IOfferDetailApplication | null;
    propertyId?: number;
    optionalOfferPhoneData?: {
        configuration: {
            phone_clip: string | null;
        };
        is_phone_clip_enabled: boolean;
    };
    useHotlineNumber?: boolean;
}

export const ApplicationFormBoxPhoneNumber = (props: IProps) => {
    const fallbackPhoneNumber = useMemo(
        () =>
            (props.optionalOfferPhoneData?.is_phone_clip_enabled && props.optionalOfferPhoneData.configuration.phone_clip) ||
            (props.isDataFetched && props.offer?.is_phone_clip_enabled && props.offer?.configuration.phone_clip) ||
            (props.isDataFetched &&
                props.offer?.sales_offices &&
                props.offer?.sales_offices.length &&
                (props.offer.sales_offices[0].phone || props.offer.sales_offices[0].mobile)) ||
            null,
        [props.optionalOfferPhoneData, props.isDataFetched, props.offer]
    );

    const trackPhoneButtonClick = (buttonName: AmplitudeOfferPageButtonName) => {
        if (!props.offerId) {
            return;
        }

        trackAmplitudeOfferButtonClick({
            buttonName,
            buttonCategory: props.propertyId != null ? "property_page" : "investment_page",
            itemId: props.offerId
        });
    };

    const handleShowPhoneNumberClick = () => {
        gtmRotatingPhoneNumbersReveal();

        trackPhoneButtonClick("offer_show_number");
    };

    const handlePhoneNumberClick = () => {
        gtmRotatingPhoneNumbersCall();

        trackPhoneButtonClick("offer_call_investor");
    };

    if (!props.isDataFetched) {
        return <Loader size="md" className={loaderStyle} />;
    }

    return !props.isAutoresponderEnabled ? (
        <>
            <Text align="center" className={separatorTextStyle} color="var(--colors-gray-700)" variant="info_txt_2">
                lub zadzwoń
            </Text>

            <ClipPhoneButton
                buttonSize="medium"
                buttonStyleOverride={buttonStyleOverride}
                fallbackNumber={fallbackPhoneNumber}
                onClickPhoneNumber={handlePhoneNumberClick}
                onShowPhoneNumber={handleShowPhoneNumberClick}
                propertyId={props.propertyId}
                className={phoneButtonWrapperStyle}
                customPhoneButton={(onClick, phoneNumber) => (
                    <div className={columnCenterStyle}>
                        <div className={phoneSectionStyle}>
                            <PhoneIcon size="2.4" wrapperColor="var(--colors-primary)" wrapperSize="4" />

                            <Link className={linkStyle} href={`tel:+${phoneNumber}`} onClick={onClick}>
                                <Text as="span" variant="headline_6" color="var(--colors-secondary)">
                                    {phoneNumberFormat(phoneNumber)}
                                </Text>
                            </Link>
                        </div>
                    </div>
                )}
                useHotlineNumber={props.useHotlineNumber}
            />
        </>
    ) : null;
};

const separatorTextStyle = css({
    my: 2
});

const buttonStyleOverride = css({
    px: 2,
    py: 1,
    maxHeight: "40px"
});

const columnCenterStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
});

const phoneSectionStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});

const linkStyle = css({
    marginLeft: 2,
    "&, &:link, &:visited, &:hover, &:active": {
        textDecoration: "none",
        color: "inherit"
    }
});

const phoneButtonWrapperStyle = css({
    width: "100%",
    textAlign: "center"
});

const loaderStyle = css({
    w: "100%",
    h: "76px",
    alignItems: "center",
    marginTop: 2,
    opacity: 0.5
});
